import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, Upload, message, UploadProps, DatePicker, FormInstance, Table, Divider, Tooltip, Popconfirm } from 'antd';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import './store-consumption-form.css';
import TextArea from 'antd/lib/input/TextArea';
import { SODto } from '@gtpl/shared-models/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { EditOutlined } from '@ant-design/icons';
import { MinusCircleOutlined } from '@ant-design/icons';
import { ItemCategoriesDto, ItemCategoryDropDownDto, ItemsDropDownDto, ProductDto } from '@gtpl/shared-models/masters';
import { AvailableStockQtyResponseModel, AvailStockDto, StoreConsumptionItemsDetails, StoreConsumptionItemsDto } from '@gtpl/shared-models/procurement-management';
import { ItemsService } from '@gtpl/shared-services/masters';
import { StockService, StoreConsumptionService } from '@gtpl/shared-services/procurement';
import { type } from 'os';
import { ColumnProps } from 'antd/lib/table';
import { IsNumber } from 'class-validator';

const { Option } = Select;

/* eslint-disable-next-line */
export interface StoreConsumptionItemsFormProps {
  form: FormInstance<any>
  addDataToItemDetails: (itemDetalFormdata: StoreConsumptionItemsDto[]) => void;
  saleOrderId: number;
  // itemsdata: (itemCatId: number) => void;
  // getAvailStock: (storeConsumptionItemsDto: StoreConsumptionItemsDto) => void;
  // availabletock:number;
  // itemsDropDown:ItemsDropDownDto[];
  // itemsCategorydata:ItemCategoryDropDownDto[];
}

export function StoreConsumptionItemsForm(
  props: StoreConsumptionItemsFormProps
) {
  const form = props.form;
  const [defaultFormData, setDefaultFormData] = useState<any>(undefined);
  const [indexVal, setIndexVal] = useState(0);
  const [tableData, setTableData] = useState<any[]>([]);
  const [showTable, setShowTable] = useState<boolean>(false);
  const [fieldsData, setFieldsData] = useState<any>(undefined);
  const [storeItemsData, setStoreItemsData] = useState(undefined);
  const [btnChange, setBtnChange] = useState<boolean>(false);
  const [qtyDisable, setQtyDisable] = useState<boolean>(true);
  const [defaultStockQty, setDefaultStockQty] = useState<number>(0);
  const [itemsdata, setItemsdata] = useState<ItemsDropDownDto[]>([]);
  const [availStockQty, setAvailStockQty] = useState<number>(0);
  const [quantity, setQuantity] = useState<string>(null);
  const [updateTableData, setUpdateTableData] = useState<any[]>([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [consumedQty, setConsumedQty] = useState<number>(0);
  
  const itemService = new ItemsService();
  const stockService = new StockService();
  const saleOrderService = new SaleOrderService();
  const storeConsumptionService = new StoreConsumptionService();
  useEffect(() => {
    if(props.saleOrderId > 0){
      form.setFieldsValue({ itemId: "select Item Name" });
      form.setFieldsValue({ availableQty: "" });

    }


    getItemsData(props.saleOrderId);
    // if (defaultFormData) {
    //   console.log(defaultFormData);
    //   form.setFieldsValue({
    //     itemCategory: !isUpdate?defaultFormData.itemCategory.children:defaultFormData.itemCategory,
    //     itemId: !isUpdate?defaultFormData.itemId.children:defaultFormData.itemId,
    //     qugetBomItemsDetailsantity: !isUpdate?defaultFormData.quantity:defaultFormData.quantity,
    //     availableQty: !isUpdate?defaultFormData.availableStock:defaultFormData.availableStock,
    //   });
    //   setFieldsData(defaultFormData);
    // }
  }, [defaultFormData]);
  const onReset = () => {
    setBtnChange(false);
    form.resetFields();
  };
  const getItemsData = (saleorder) => {
    console.log(saleorder);
    saleOrderService.getBomItemsDetails({ saleOrderId: saleorder }).then((res) => {
      console.log(res.data);
      if (res.status) {
        setItemsdata(res.data);
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
        setItemsdata([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setItemsdata([]);
    });
  }

  const getAvailableStock = (reqData, saleOrderId) => {
    console.log(reqData, saleOrderId);
    stockService.getAvailableStockQty({ saleOrderId: saleOrderId, itemId: reqData, unitId: Number(localStorage.getItem('unit_id')), role: JSON.parse(localStorage.getItem('role')) }).then((res) => {
      console.log(res);
      if (res.status && res.data.physicalQuantity > 0) {
        setAvailStockQty(res.data.physicalQuantity);
        // const { label } = row;
        // setFieldsData({ ...fieldsData, 'availableStock': res.data.physicalQuantity ,  [label]: row })
        form.setFieldsValue({ availableQty: res.data.physicalQuantity });
        setQtyDisable(false);
      } else {
        console.log(res.internalMessage)
        AlertMessages.getErrorMessage(res.internalMessage);
        form.setFieldsValue({ availableQty: "" });
        form.setFieldsValue({ quantity: "" });
        form.setFieldsValue({ itemCategory: "Select Item Category" });
        form.setFieldsValue({ itemId: "select Item Name" });
        setQuantity("");
        setQtyDisable(true);
        // }
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setAvailStockQty(undefined);
    });
  }
  const appendData = (val, row) => {
    let saleorder = 0;
    // props.itemsCategorydata.forEach(data => {
    //   console.log(data.saleOrderId);
    //   saleorder = data.saleOrderId;
    // })
    console.log(val);
    console.log(row);
    const { label } = row;
    setFieldsData({ ...fieldsData, [label]: row })
    console.log(fieldsData);
    // if(row.label === "itemCategory"){
    //   getItemsData(saleorder);
    // }
    if (row.label === "itemId") {
      getAvailableStock(val, props.saleOrderId);
      getConsumedStock(val, props.saleOrderId);
    }
  }

  const getConsumedStock = (itemid, saleOrderId) =>{
    setConsumedQty(0);
    storeConsumptionService.getConsumedStock({ saleOrderId: saleOrderId, itemId: itemid, unitId: Number(localStorage.getItem('unit_id')), role: JSON.parse(localStorage.getItem('role')) }).then((res) => {
      if (res.status) {
        setConsumedQty(Number(res.data.consumedQty));
      } else {
        setConsumedQty(0);
      }
    }).catch((err) => {
      setConsumedQty(0);
      AlertMessages.getErrorMessage(err.message);
    });
  }

  const setEditForm = (rowData, index) => {
    getConsumedStock(rowData.itemId, props.saleOrderId);
    console.log(rowData);
    setDefaultFormData(rowData);
    setIndexVal(index);
    setBtnChange(true);

    form.setFieldsValue({
      // itemCategory: !isUpdate?rowData.itemCategory.children:rowData.itemCategory,
      itemId: !isUpdate ? rowData.itemId.children : rowData.itemId,
      quantity: !isUpdate ? rowData.quantity : rowData.quantity,
      availableQty: !isUpdate ? rowData.availableStock : rowData.availableStock,
    });
    setFieldsData(rowData);

    // setIsUpdate(true);

  }
  const deleteData = (index) => {
    console.log(index)
    tableData.splice(index, 1);
    setTableData([...tableData]);
    if (tableData.length == 0) {
      setShowTable(false)
    }
  }
  const columns: ColumnProps<any>[] = [
    // {
    //   title: 'Item Category',
    //   dataIndex: 'itemCategory',
    //   render: (text, data, index) => {
    //     // console.log(text, data, index)
    //     return <span>{data.itemCategory.children}</span>
    //   }
    // },
    {
      title: 'Item Name',
      dataIndex: 'itemId',
      key: 'itemId',
      align: 'left',
      render: (text, data, index) => {
        // console.log(text, data, index)
        return <span>{data.itemId.children}</span>
      }
    },
    {
      title: 'Available Quantity',
      dataIndex: 'availableStock',
      key: 'availableStock',
      align: 'left',
    },
    {
      title: 'Consumed Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'left',
    },

    {
      title: 'Action',
      dataIndex: 'action',
      // width: '20%',
      render: (text, rowData: any, index) => (
        <span>
          <Tooltip placement="top" title='edit'>
            <EditOutlined className={'editSamplTypeIcon'} type="edit"
              onClick={() => {
                if (rowData) {
                  console.log(rowData);
                  setEditForm(rowData, index);
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip placement="top" title='dlete'>
          <Popconfirm title='Sure to delete?' onConfirm={e =>{deleteData(index);}}>
            <MinusCircleOutlined 
              style={{ color: '#1890ff', fontSize: '14px' }} />
            </Popconfirm>

          </Tooltip>
        </span>)
    }

  ]
  const appendInputData = (val, label) => {
    console.log(val);
    console.log(label);

    if (label == "quantity") {
      setFieldsData({ ...fieldsData, [label]: val });
      const quantity: number = val;
      const stockQty: number = form.getFieldValue("availableQty");
      console.log(stockQty);
      console.log(quantity);
      if (Number(quantity) > Number(stockQty) || Number(quantity) <= 0) {
        form.setFieldsValue({ quantity: "" });
        AlertMessages.getErrorMessage('Consumed Quantity must be less than Available Quantity');
        // form.setFieldsValue({quantity:0});
        return false;
      }
    }
    else if (label == "availableQty") {
      console.log(label);
      console.log(val.availStockQty);
      setFieldsData({ ...fieldsData, [label]: val.availStockQty });
    }
  }


  const saveSaleOrderItems = (values: any) => {
    console.log(values);
    setFieldsData(values);
    form.validateFields().then(storeConsumptionres => {
      setConsumedQty(0);
      let tableName = tableData;
      console.log(tableData);
      console.log(fieldsData);
      console.log(isUpdate);
      let duplicateData;
      if (!btnChange) {
        duplicateData = tableName.find(item => (item.itemId.key == fieldsData.itemId.key));
      }
      else {
        console.log(indexVal);
        duplicateData = tableName.find(item => (item.itemId.key == fieldsData.itemId.key && item.quantity == fieldsData.quantity));
      }

      if (duplicateData) {
        AlertMessages.getErrorMessage('Item already exist in Store Consumption Items. ');
        onReset();
      } else {
        // console.log('btnChangetest');

        if (!btnChange) {
          console.log('btnChange');
          form.validateFields().then(res => {
            setShowTable(true);
            fieldsData.availableStock = values.availableQty;
            let dynTableData = [...tableData, fieldsData]
            // console.log(fieldsData.availableStock);
            // console.log(tableData);
            // console.log(dynTableData);
            setTableData(dynTableData);
            props.addDataToItemDetails(dynTableData);
          })
        } else {
          console.log('values');
          console.log(tableData);
          console.log(values);
          console.log(fieldsData);
          console.log(indexVal);
          console.log(form.getFieldValue('itemCategory'));
          console.log(form.getFieldValue('itemId'));
          let dynTableData = [...tableData]
          // dynTableData[indexVal].itemCategory=fieldsData.itemCategory
          dynTableData[indexVal].itemId = fieldsData.itemId
          dynTableData[indexVal].quantity = fieldsData.quantity
          dynTableData[indexVal].availableStock = fieldsData.availableStock
          // let dynTableData = [...tableData]
          // dynTableData[indexVal] = fieldsData
          // console.log(dynTableData);
          setShowTable(true);
          setTableData(dynTableData);
          props.addDataToItemDetails(dynTableData);



        }
        onReset();
      }
    })
  };
  return (
    <Card title={<span style={{ color: 'white' }}>Store Item Details </span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
      <Form layout="vertical" form={form} name="control-hooks" onFinish={saveSaleOrderItems}>
        <Row gutter={24}>

          <Col span={8}>
            <Form.Item name="itemId" label="Item Name" rules={[{ required: true, message: "'itemName' is required" }]}>
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Item Name"
                onChange={appendData}


                // onChange={getAvailableStock} 
                allowClear
              >
                <Option key={0} value={null}>Select Item Name</Option>
                {itemsdata.map(dropData => {
                  return <Option key={dropData.itemId} label='itemId' value={dropData.itemId}>{dropData.itemName}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4} >
            <Form.Item name="availableQty" label="Available Quantity" rules={[{ required: true }]}  >
              <Input disabled onClick={e => appendInputData({ availStockQty }, 'availableQty')} value={availStockQty} />
            </Form.Item>
          </Col>
          <Col span={4} >
          <label><span style={{ color: 'red' }}>Total IssUed Qty :{consumedQty}</span><span style={{ color: 'red' }}>*</span>Consumed Quantity: </label>
            <br />
            <Form.Item name="quantity" label={false} rules={[{ required: true, message: "'Consumed Quantity' is required " }]}  >
              <Input type='number' disabled={qtyDisable} onChange={e => appendInputData(e.target.value, 'quantity')} value={quantity} />
            </Form.Item>
          </Col>
      

          <Col span={2}>
            <Form.Item style={{padding:'3em'}}>

  
              <Button style={{ backgroundColor: "#67b32d", color: "white" }} type="primary" htmlType="submit" >
                {btnChange ? 'UPDATE' : 'ADD'}
              </Button>
              {/* <Button style={{ backgroundColor: "#67b32d", color: "white" }} onClick={onAddProduct} block >
                    Add
                    </Button> */}
            </Form.Item>
          </Col>
          <Col span={1}>
            <Form.Item style={{padding:'3em'}}>
            

              <Button style={{ backgroundColor: "#f19c9b", color: "white" }}

                onClick={onReset}
              >
                Reset
              </Button>
            </Form.Item>
          </Col>

          {/* <Col span={6}>
                    <MinusCircleOutlined onClick={() => remove(field.name)} />
                </Col> */}
        </Row>
        <br />
        {showTable ?
          <Table key={Date.now()} scroll={{ x: 500 }} dataSource={tableData}
            columns={columns} pagination={false} /> :
          <></>
        }
        {/* {
            showTable ?
              <Table dataSource={tableData} columns={columns} pagination={false} /> :
              <></>
          } */}
      </Form>

    </Card>
  );
}

export default StoreConsumptionItemsForm;
